/**
 * Formato de números para los mensajes del motor.
 *
 * El motor no puede usar `Intl` de la app porque los mensajes se generan aquí,
 * pero SÍ tiene que escribir en español: coma decimal, como manda el spec.
 * Es una función pura, sin dependencias del navegador.
 */
export function num(value: number, decimals?: number): string {
  const places = decimals ?? (Number.isInteger(value) ? 0 : 1);
  const fixed = value.toFixed(places);
  return fixed.replace('.', ',');
}

/** "2 series" / "1 serie". Evita el "1 series" que delata a una app traducida. */
export function plural(count: number, singular: string, pluralForm: string): string {
  return `${num(count)} ${count === 1 ? singular : pluralForm}`;
}

/** Une una lista en español: "a, b y c". */
export function joinEs(items: readonly string[]): string {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0]!;
  return `${items.slice(0, -1).join(', ')} y ${items[items.length - 1]!}`;
}
